import React, { useState } from 'react';
import SectionOne from './SectionOne';
import SectionTwo from './SectionTwo';
import SectionThree from './SectionThree';
import SectionFour from './SectionFour';

export default function SignupContentSwitcher() {
  const [section, setSection] = useState(1);
  const [managerInfo, setManagerInfo] = useState('');

  switch (section) {
    case 1:
      return <SectionOne setSection={setSection} />;
    case 2:
      return <SectionTwo setSection={setSection} managerInfo={managerInfo} setManagerInfo={setManagerInfo} />;
    case 3:
      return <SectionThree setSection={setSection} managerInfo={managerInfo} />;
    case 4:
      return <SectionFour setSection={setSection} />;
    default:
      return <SectionOne setSection={setSection} />;
  }
}
